import {CONTENT_TYPE_TEXT, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'RDS_2',
  title: 'Wie kann ich die Dokumente meiner Nachunternehmer aktualisieren?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Sie können den OFA-Service bitten, die Dokumente Ihrer Nachunternehmer kostenlos zu erneuern, wenn ein oder mehrere Dokumente nicht auf dem neuesten Stand sind. Dazu müssen Sie nur auf die Schaltfläche "Erinnern" in der Zeile Ihres Zulieferers klicken.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Bitte beachten Sie, dass wir zusätzlich zu Ihren Erinnerungen auch regelmäßig Erinnerungen versenden, wenn Dokumente nicht auf dem neuesten Stand sind.'
  }]
};
